export const readPageParam = (params) => {
  const page = Number.parseInt(params.get("page") ?? "1", 10);
  return Number.isFinite(page) && page > 0 ? page : 1;
};

/** State passed when leaving a paginated list for a detail view. */
export const getListNavigationState = (location) => ({
  listSearch: location.search || "",
  listPath: location.pathname || "",
});

/** Full URL to restore when returning to a list (pathname + search). */
export const getListReturnTo = (location) =>
  `${location.pathname || ""}${location.search || ""}`;